import { rootApi } from "../../api/rootApi";


export const workflowApi = rootApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchWorkflows: builder.query({
            query: (token) => {
                return {
                method: 'GET',
                url: '/admin/workflow',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                  },
            }}
        }),
        addWorkflow : builder.mutation({
            query: (params) => {
                return {
                method: 'POST',
                url: '/admin/workflow/add',
                headers: {
                    "Content-Type": "application/json",
                    authorization: "Bearer " + params.token,
                },
                body : JSON.stringify(params.body)
            }}
        }),
        
    })

});
export const { useFetchWorkflowsQuery , useAddWorkflowMutation } = workflowApi;